module.exports = __webpack_public_path__ + "img/toumingmochoubiandai.min.523d2b18.png";